import { PERMISSION } from "@app/modules/roles/constants";

interface VerticalMenuBasic {
  icon: string;
  text: string;
  link: string;
  unavailableRegions?: string[];
  highlight?: boolean;
  permission?: PERMISSION;
  permissions?: PERMISSION[];
  disabledWhen?: string[];
  cashlessOnly?: boolean;
}
interface VerticalMenuNested {
  icon: string;
  text: string;
  unavailableRegions?: string[];
  subsections: Omit<VerticalMenuBasic, "icon">[];
  permission?: PERMISSION;
  permissions?: PERMISSION[];
  cashlessOnly?: boolean;
}

export type VerticalMenuItem = VerticalMenuBasic | VerticalMenuNested;

export const DISMISSED_HEADER_LS_KEY = "dismissed-header-announcement-";
export const DISMISSED_NOTIFICATION_LS_KEY = "dismissed-notification-announcement-";
export const DISMISSED_BANNER_LS_KEY = "dismissed-banner-announcement-";

export const DISABLED_WHEN_NO_PP = "no-pp";
export const DISABLED_WHEN_NO_ORDERS = "no-orders";
